import mutations from './mutations'
import actions from "./actions";
const menu = {
    namespaced: true,
    state: {
        postNum: ''
    },
    mutations,
    actions
}
export default menu